/**
 * Show element only when the other element is overflowed
 * @module modules/showOnOverflow
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'showOnOverflow';
export const DEFAULTS = {
  overflowEl: null,
  hideThis: null,
};

const checkOverflow = ($el, $overflowEl, $toggleThis) => {
  if ($overflowEl[0].offsetWidth < $overflowEl[0].scrollWidth) {
    $toggleThis.show();
  } else {
    $toggleThis.hide();
  }
};

export default function showOnOverflow(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const $overflowEl = $(opts.overflowEl);
  const $toggleThis = opts.hideThis ? $(opts.hideThis) : $el;
  checkOverflow($el, $overflowEl, $toggleThis);
}

registerJQueryPlugin(PLUGIN_NAME, showOnOverflow);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/show-on-overflow.js